import { render, staticRenderFns } from "./VisitMove.vue?vue&type=template&id=177db234"
import script from "./VisitMove.vue?vue&type=script&lang=js"
export * from "./VisitMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports